import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  contactUsApiKey,
  contactusAPI,
  keyRecaptcha,
  recaptchaAPI,
} from "../../Constants/ConfigureApi";

export const verifyCaptcha = createAsyncThunk(
  "contactUs/reCaptcha",
  // eslint-disable-next-line
  async (payload: any, thunkAPI) => {
    try {
      // TO DO: The service will be created to do the validation
      const url = `/siteverify?secret=${keyRecaptcha}&response=${payload}`;
      const response = await recaptchaAPI.create(url, {}, "");
      return response;
    } catch (error) {
      thunkAPI.rejectWithValue(error);
    }
  }
);

export const CreateContactUs = createAsyncThunk(
  "contactUs/CreateContactUs",

  async (payload: FormData, thunkAPI) => {
    try {
      const response = await contactusAPI.createFormEncoded(
        "/contactform",
        payload,
        contactUsApiKey
      );
      return response;
    } catch (error) {
      thunkAPI.rejectWithValue(error);
    }
  }
);
